<template>
  <!-- The live region stays mounted even with no error: a region inserted
       together with its text is not announced, so the first error would be
       silent. Only the text and the visual box change. -->
  <div
    :id="id"
    role="alert"
    aria-live="polite"
    :class="{ 'error-alert': error }"
  >
    {{ error }}
  </div>
</template>

<script setup>
defineProps({
  error: {
    type: String,
    default: '',
  },
  id: {
    type: String,
    required: true,
  },
});
</script>

<style scoped lang="scss">
.error-alert {
  margin-bottom: 2rem; /* 32px */
  padding: 1rem; /* 16px */
  border-radius: 1rem; /* 16px - rounded-2xl */
  background-color: rgb(254 242 242); /* red-50 */
  border: 1px solid rgb(254 202 202); /* red-200 */
  color: rgb(220 38 38); /* red-600 */
  font-size: 1rem; /* 16px */

  @media (prefers-color-scheme: dark) {
    background-color: rgb(127 29 29 / 0.5); /* red-950/50 */
    border-color: rgb(127 29 29); /* red-900 */
    color: rgb(252 165 165); /* red-300 */
  }

  /* Override global [aria-live] off-screen hiding in _accessibility.scss —
     this alert must be visible to sighted users, not just screen readers. */
  &[aria-live] {
    position: static;
    left: auto;
    width: auto;
    height: auto;
    overflow: visible;
  }
}
</style>
